import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  address1_Line1: string;
  address1_Line2?: string;
  address1_City: string;
  address1_StateOrProvince: string;
  address1_PostalCode: string;
  address1_County: string;
}

@Component({
    selector: 'ebb-policy-dialog',
    templateUrl: './policy-dialog.component.html',
    styleUrls: ['./policy-dialog.component.scss'],
    standalone: false
})
export class PolicyDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<PolicyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  public onClickClose(): void {
    this.dialogRef.close();
  }
}
